module.exports = __webpack_public_path__ + "static/img/integration.4ebd286e.jpg";